<template>
  <div class="confirmation">
    <step-header
      :title="headerTitle"
      :subtitle="locationName"
    />
    <div class="body">
      <div class="testimonial">
        <div class="check-container">
          <div class="check-wrapper">
            <svg
              class="check-icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <polyline
                points="20 6 9 17 4 12"
                stroke="#fff"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>
        <p class="thank">
          Thank you so much for your review! We value your feedback and will continue to improve our services.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StepHeader from '@/components/StepHeader/StepHeader.vue'
import { trackView } from '@/analytics'

export default {
  name: 'Confirmation',
  components: { StepHeader },
  computed: {
    ...mapGetters({
      headerTitle: 'reputation/headerTitle',
      locationName: 'reputation/locationName',
      analyticsDims: 'reputation/analyticsDims'
    })
  },
  created () {
    trackView(this, 'feedback_confirm', this.analyticsDims)
  }
}
</script>

<style lang="scss" scoped>
.testimonial {
  padding: 0 50px;

  @include mobile {
    padding: 0;
  }
}

.check-container {
  margin: 20px 0 16px;
  text-align: center;

  .check-wrapper {
    align-items: center;
    background: var(--color-primary, #555f7e);
    border: 2px solid var(--color-primary, #555f7e);
    border-radius: 50%;
    display: inline-flex;
    height: 80px;
    justify-content: center;
    width: 80px;

    .check-icon {
      height: 40px;
      width: 40px;
    }
  }
}

.thank {
  color: $text-primary;
  font-size: 16px;
  line-height: 1.4;
  margin: 0 auto;
  max-width: 80%;
  text-align: center;
}
</style>
